import JobCardList from "../JobCardList";
import TaskCardList from "../TaskCardList";
import {isTaskJob} from "./schedulerUtils";

export default function SchedulerCard({
    cleanerHint = null,
    fieldSupervisorMap,
    fieldWorkerMap,
    isAgencyBlocked,
    isLoading,
    job,
    mobileAction,
    onAssignCleaner,
    onEditJob,
    onOpenWorkItems,
    onJobUpdated,
    onIssueSummaryChanged,
    sameDayAssignmentLabel,
    sameDaySchedule,
    dragSourceZone,
}) {
    const taskJob = isTaskJob(job);
    const sharedProps = {
        fieldWorkerMap,
        isLoading,
        isAgencyBlocked,
        job,
        mobileAction,
        onEditJob,
        onJobUpdated,
        sameDayAssignmentLabel,
        sameDaySchedule,
        dragSourceZone,
    };

    const card = taskJob ? (
        <TaskCardList {...sharedProps} onOpenWorkItems={onOpenWorkItems} />
    ) : (
        <JobCardList
            {...sharedProps}
            fieldSupervisorMap={fieldSupervisorMap}
            onJobUpdated={onJobUpdated}
            onIssueSummaryChanged={onIssueSummaryChanged}
            cleanerHint={cleanerHint}
            onAssignCleaner={onAssignCleaner}
        />
    );

    return (
        <div inert={isLoading ? true : undefined} aria-disabled={isLoading || undefined}>
            {card}
        </div>
    );
}
